var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-tertiary btn-lg save-close ignore",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.submit}},[_vm._v("\n  "+_vm._s(_vm.lang.get('buttons.saveClose'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }